import CeBlobButtonGroup from '../../../../../../../app/assets/javascripts/repository/components/header_area/blob_button_group.vue?vue3';
import { DEFAULT_BLOB_INFO } from '~/repository/constants';
import glLicensedFeaturesMixin from '~/vue_shared/mixins/gl_licensed_features_mixin';
import glFeatureFlagsMixin from '~/vue_shared/mixins/gl_feature_flags_mixin';
import LockFileDropdownItem from './lock_file_dropdown_item.vue?vue3';
export default {
    name: 'BlobButtonGroupEE',
    components: {
        CeBlobButtonGroup,
        LockFileDropdownItem
    },
    mixins: [
        glLicensedFeaturesMixin(),
        glFeatureFlagsMixin()
    ],
    inject: {
        blobInfo: {
            default: ()=>DEFAULT_BLOB_INFO.repository.blobs.nodes[0]
        }
    },
    props: {
        ...CeBlobButtonGroup.props,
        projectPath: {
            type: String,
            required: true
        },
        canCreateLock: {
            type: Boolean,
            required: true
        },
        canDestroyLock: {
            type: Boolean,
            required: true
        },
        isLocked: {
            type: Boolean,
            required: true
        },
        isLoading: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'show-fork-suggestion'
    ],
    methods: {
        onShowForkSuggestion () {
            this.$emit('show-fork-suggestion');
        }
    }
};
